var map = {
	"./1-2.png": "./src/assets/panel/1-2.png",
	"./2-2.png": "./src/assets/panel/2-2.png",
	"./3-2.png": "./src/assets/panel/3-2.png",
	"./4-2.png": "./src/assets/panel/4-2.png",
	"./5-2.png": "./src/assets/panel/5-2.png",
	"./6-2.png": "./src/assets/panel/6-2.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/panel sync recursive ^\\.\\/.*\\-2\\.png$";